/* global locales */
import angular from 'angular';
import 'ng-file-upload';
import 'angular-bootstrap';
import 'angular-sanitize';
import 'ui-select';
import 'ng-table';
import './newspapersServices';
import locales from '../../locale';

// Define the missing function
angular.checkSelectedElements = (array, item) => {
    'use strict';
    return array.includes(item.id);
};

const newspapersControllers = angular.module('applicationModule.newspapersControllers', [
    'ngSanitize',
    'applicationModule.newspapersServices',
    'ui.bootstrap',
    'ui.select',
    'ngTable'
]);

newspapersControllers.controller('NewspapersController', ['$scope', '$rootScope', '$state', '$stateParams', '$modal', '$filter', 'NgTableParams', 'growl', 'Newspaper', 'AppsoupAPI', 'Permissions', '$locale', function ($scope, $rootScope, $state, $stateParams, $modal, $filter, NgTableParams, growl, Newspaper, AppsoupAPI, Permissions, $locale) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.app_id = $stateParams.application_id;
    $scope.check = false;
    $scope.search = {};
    $scope.types = [];
    $scope.lang = $filter('translate')('LANG');
    if (locales[$scope.lang] && locales[$scope.lang].DATETIME_FORMATS) {
        angular.copy(locales[$scope.lang].DATETIME_FORMATS, $locale.DATETIME_FORMATS);
    }
    $scope.writeAccess = Permissions.hasWriteAccess('newspapers');
    $scope.buttonLoadClass = '';
    $scope.checkedNewspapers = [];
    $scope.importNewspaperLoading = false;

    var refresh = true;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getTitleTableParams('title'), {
        getData: function (params) {
            $scope.isLoading = true;
            return Newspaper.getList($scope.app_id, params._params)
                .then(function (response) {
                    params.total(response.newspapers.total);
                    params.count(response.newspapers.per_page);
                    params.page(response.newspapers.current_page);
                    return response.newspapers.data;
                })
                .finally(function () {
                    $scope.isLoading = false;
                    $scope.isFind = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.copy = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.copyNewspaper = function (id) {
        Newspaper.copy(id).then(function (response) {
            const data = response.data;
            if (data.success) {
                growl.success('MODULES.NEWSPAPERS.GROWL.SUCCESS.COPY');
                $state.go($state.current, {searchNewspapers: $stateParams.searchNewspapers}, {reload: true});
            } else {
                growl.error('MODULES.NEWSPAPERS.GROWL.ERROR.COPY');
            }
        }).catch(function (error) {
            growl.error('MODULES.NEWSPAPERS.GROWL.ERROR.COPY');
        });
    };

    $scope.removeNewspaper = function (id, index) {
        Newspaper.remove(id).then(function (response) {
            const data = response.data;
            if (data.success) {
                growl.success('MODULES.NEWSPAPERS.GROWL.SUCCESS.DELETED');
                $scope.tableParams.data.splice(index, 1);
            } else {
                growl.error('MODULES.NEWSPAPERS.GROWL.ERROR.DELETED');
            }
        }).catch(function (error) {
            growl.error('MODULES.NEWSPAPERS.GROWL.ERROR.DELETED');
        });
    };

    $scope.importNewspaper = function (newspaperId, mutationId) {
        $scope.buttonLoadClass = 'fa-spin fa-fw';
        $scope.importNewspaperLoading = true;
        Newspaper.import($scope.app_id, newspaperId, mutationId).then(function (response) {
            growl.success('MODULES.NEWSPAPERS.GROWL.SUCCESS.IMPORT');
        }).catch(function (error) {
            growl.error('MODULES.NEWSPAPERS.GROWL.ERROR.IMPORT', {title: error.data && error.data.message ? error.data.message : 'Error'});
        }).finally(function () {
            $scope.buttonLoadClass = '';
            $scope.importNewspaperLoading = false;
            $state.go($state.current, {searchNewspapers: $stateParams.searchNewspapers}, {reload: true});
        });
    };

    $scope.searchNewspapers = function (search) {
        $scope.isFind = true;

        search.from_date = $filter('date')(search.from_date, 'yyyy-MM-dd');
        search.to_date = $filter('date')(search.to_date, 'yyyy-MM-dd');

        var find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.isFind = false;
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.name)) {
            $scope.tableParams._params.name = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.type)) {
            $scope.tableParams._params.type = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.from_date)) {
            $scope.tableParams._params.from_date = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.to_date)) {
            $scope.tableParams._params.to_date = undefined;
        }
    };

    $scope.searchTypes = function (text) {
        text = $filter('removeSpecial')(text);

        Newspaper.search($scope.app_id, text).then(function (response) {
            const data = response.data;
            if (data.success) {
                $scope.types = data.types;
            } else {
                growl.error('MODULES.NEWSPAPERS.GROWL.ERROR.' + data.error);
            }
        }).catch(function (error) {
            growl.error('MODULES.NEWSPAPERS.GROWL.ERROR.SEARCH');
        });
    };

    $scope.selectNewspaper = function (id) {
        $scope.checkedNewspapers = angular.selectElement($scope.checkedNewspapers, id);
    };

    $scope.selectAllNewspapers = function (item) {
        $scope.checkedNewspapers = angular.selectAllElements($scope.checkedNewspapers, item);
    };

    $scope.checkSelectedNewspapers = function (item) {
        return angular.checkSelectedElements($scope.checkedNewspapers, item);
    };

    $scope.bulkDelete = function () {
        Newspaper.bulkDelete($scope.checkedNewspapers)
            .then(function (response) {
                const data = response.data;
                if (data.success) {
                    growl.success('MODULES.NEWSPAPERS.GROWL.SUCCESS.BULK_DELETE');
                } else {
                    growl.error('MODULES.NEWSPAPERS.GROWL.ERROR.BULK_DELETE');
                }
            })
            .catch(function (error) {
                growl.error('MODULES.NEWSPAPERS.GROWL.ERROR.BULK_DELETE');
            })
            .finally(function () {
                refreshData();
            });
    };

    function refreshData() {
        $scope.searchNewspapers({refresh: refresh});
        refresh = !refresh;
        $scope.checkedNewspapers = [];
    }

    $scope.$watch('search', function () {
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
        });
    }, true);
}]);

newspapersControllers.controller('NewspaperController', ['$scope', '$rootScope', '$state', '$stateParams', 'growl', 'Newspaper', '$filter', function ($scope, $rootScope, $state, $stateParams, growl, Newspaper, $filter) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});

    $scope.editMode = false;
    var appId = $stateParams.application_id;
    $scope.newspaper = {
        app_id: appId,
        gender: null
    };
    $scope.genders = [
        {key: 'GENDER.ANY', value: 'any'},
        {key: 'GENDER.FEMALE', value: 'female'},
        {key: 'GENDER.MALE', value: 'male'}
    ];
    $scope.selectedGender = 'any';

    if (angular.isDefined($stateParams.newspaperId)) {
        $scope.editMode = true;
    }

    Newspaper.getPackageId(appId)
        .then(function (response) {
            const data = response.data;
            if (data.success) {
                $scope.package_id = data.package_id;
            }
        });

    if ($scope.editMode) {
        Newspaper.get($stateParams.newspaperId)
            .then(function (response) {
                const data = response.data;
                if (data.success) {
                    $scope.newspaper = data.newspaper;
                    $scope.selectedGender = data.newspaper.gender ? data.newspaper.gender : 'any';
                    if ($scope.newspaper.types) {
                        if (data.package_id !== 'e.leclerc') {
                            $scope.newspaper.types = $scope.newspaper.types[0];
                        }
                    }
                    if ($scope.newspaper.promotion) {
                        $scope.newspaper.promotion = $scope.newspaper.promotion[0];
                    }
                } else {
                    $state.go('appsoup.application.newspapers', {application_id: $stateParams.application_id}, growl.error('MODULES.NEWSPAPERS.GROWL.ERROR.NO_DATA'));
                }
            })
            .catch(function (error) {
                $state.go('appsoup.application.newspapers', {application_id: $stateParams.application_id}, growl.error('MODULES.NEWSPAPERS.GROWL.ERROR.NO_DATA'));
            })
            .finally(function () {
                $rootScope.doingResolve = false;
            });
    }

    $scope.changeDate = function (from_to) {
        if (angular.isDefinedNotNull($scope.newspaper.to_date) && angular.isDefinedNotNull($scope.newspaper.from_date)) {
            $scope.newspaper.from_date = $filter('date')($scope.newspaper.from_date, 'yyyy-MM-dd');
            $scope.newspaper.to_date = $filter('date')($scope.newspaper.to_date, 'yyyy-MM-dd');

            if (from_to) {
                if ($scope.newspaper.from_date > $scope.newspaper.to_date) {
                    $scope.newspaper.to_date = $scope.newspaper.from_date;
                }
            } else {
                if ($scope.newspaper.to_date < $scope.newspaper.from_date) {
                    $scope.newspaper.from_date = $scope.newspaper.to_date;
                }
            }
        }
    };

    $scope.searchTypes = function (text) {
        text = $filter('removeSpecial')(text);

        Newspaper.search(appId, text).then(function (response) {
            const data = response.data;
            if (data.success) {
                $scope.types = data.types;
            } else {
                growl.error('MODULES.NEWSPAPERS.GROWL.ERROR.' + data.error);
            }
        }).catch(function (error) {
            growl.error('MODULES.NEWSPAPERS.GROWL.ERROR.SEARCH');
        });
    };

    $scope.types = [];

    $scope.changeTypes = function () {
        if (angular.isDefined($scope.newspaper.types)) {
            var tmpTypes = [];
            angular.forEach($scope.newspaper.types, function (value) {
                value = $filter('removeSpecial')(value);
                if (angular.isDefined(value) && tmpTypes.indexOf(value) === -1) {
                    tmpTypes.push(value);
                }
            });
            $scope.newspaper.types = tmpTypes;
        }
    };

    $scope.searchPromotions = function (text) {
        text = $filter('removeSpecial')(text);

        Newspaper.searchPromotions(appId, text).then(function (response) {
            const data = response.data;
            if (data.success) {
                $scope.promotions = data.promotions;
            } else {
                growl.error('MODULES.NEWSPAPERS.GROWL.ERROR.' + data.error);
            }
        }).catch(function (error) {
            growl.error('MODULES.NEWSPAPERS.GROWL.ERROR.UNKNOWN');
        });
    };

    $scope.promotions = [];

    $scope.changeGender = function (selectedGender) {
        $scope.newspaper.gender = selectedGender.value === 'any' ? null : selectedGender.value;
        $scope.selectedGender = selectedGender.value;
    };

    $scope.save = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;
        Newspaper.save($scope.newspaper, $scope.editMode).then(function (response) {
            const data = response.data;
            if (data.success) {
                growl.success('MODULES.NEWSPAPERS.GROWL.SUCCESS.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                $state.go('appsoup.application.newspapers', {application_id: appId});
            } else {
                if (typeof data.error === 'object') {
                    $scope.formErrors = data.error;
                } else {
                    growl.error('MODULES.NEWSPAPERS.GROWL.ERROR.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                }
            }
        }).catch(function (error) {
            growl.error('MODULES.NEWSPAPERS.GROWL.ERROR.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.newspapers', {application_id: appId});
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'newsletter_url': [{type: '$invalid', msg: 'MODULES.NEWSPAPERS.ERROR.URL'}],
        'from_date': [{type: '$invalid', msg: 'FORM.ERRORS.FORMAT'}],
        'to_date': [{type: '$invalid', msg: 'FORM.ERRORS.FORMAT'}],
        'min_age': [{error: 'max', msg: 'ERROR.MIN_AGE_BIGGER_MAX'}, {error: 'min', msg: 'ERROR.MIN_AGE_ZERO'}],
        'max_age': [{error: 'min', msg: 'ERROR.MAX_AGE_SMALLER_MIN'}]
    };
}]).config([
    'datepickerConfig',
    'datepickerPopupConfig',
    function (datepickerConfig, datepickerPopupConfig) {
        'use strict';
        angular.extend(datepickerConfig, {
            showWeeks: false
        });

        angular.extend(datepickerPopupConfig, {
            showButtonBar: false
        });
    }
]);

newspapersControllers.controller('NewspaperPagesController', ['$scope', '$rootScope', '$state', '$stateParams', '$modal', 'NgTableParams', 'growl', 'NewspaperPage', 'AppsoupAPI', 'Permissions', 'Newspaper', '$locale', '$filter', function ($scope, $rootScope, $state, $stateParams, $modal, NgTableParams, growl, NewspaperPage, AppsoupAPI, Permissions, Newspaper, $locale, $filter) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.app_id = $stateParams.application_id;
    $scope.newspaperId = $stateParams.newspaperId;
    $scope.lang = $filter('translate')('LANG');
    if (locales[$scope.lang] && locales[$scope.lang].DATETIME_FORMATS) {
        angular.copy(locales[$scope.lang].DATETIME_FORMATS, $locale.DATETIME_FORMATS);
    }

    $scope.writeAccess = Permissions.hasWriteAccess('newspapers');
    $scope.newspaper = {};
    $scope.headerTitle = [];
    $scope.showImportButton = false;

    var data;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getOrderTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return NewspaperPage.getList($scope.app_id, $scope.newspaperId, params._params)
                .then(function (response) {
                    if (response && response.newspaperPages && response.newspaperPages.total !== undefined) {
                        params.total(response.newspaperPages.total);
                        params.count(response.newspaperPages.per_page);
                        params.page(response.newspaperPages.current_page);
                        return response.newspaperPages.data || [];

                        if (response.newspaperPages.total > 0) {
                            $scope.showImportButton = true;
                        }
                    } else {
                        // Handle case when newspaper pages data is not available or incomplete
                        params.total(0);
                        params.count(10);
                        params.page(1);
                        return [];
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                    $scope.isFind = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    Newspaper.get($scope.newspaperId)
        .then(function (response) {
            const data = response.data;
            if (data.success) {
                $scope.newspaper = data.newspaper;
                $scope.headerTitle.push('(' + $scope.newspaper.name + ')');
            } else {
                growl.error('MODULES.NEWSPAPERS.GROWL.ERROR.' + data.error);
            }
        })
        .catch(function (error) {
            growl.error('MODULES.NEWSPAPERS.GROWL.ERROR.GET');
        })
        .finally(function () {
            $rootScope.doingResolve = false;
        });


    $scope.changeOrder = function ($event, key1, key2) {
        $event.stopImmediatePropagation();
        data = {
            order_ids: [$scope.tableParams.data[key1].id, $scope.tableParams.data[key2].id],
            application_id: $scope.app_id
        };

        NewspaperPage.changeOrder(data).then(function (response) {
            const data = response.data;
            if (data.success) {
                var dataNew = $scope.tableParams.data;

                return angular.changeOrderResponse(dataNew, key1, key2);
            }
        }).catch(function (error) {
            growl.error('MODULES.NEWSPAPERS.PAGES.GROWL.ERROR.CHANGE_ORDER');
        });
    };

    $scope.removeNewspaperPage = function (id, index) {
        NewspaperPage.remove(id).then(function (response) {
            const data = response.data;
            if (data.success) {
                growl.success('MODULES.NEWSPAPERS.PAGES.GROWL.SUCCESS.DELETED');
                $scope.tableParams.data.splice(index, 1);
            } else {
                growl.error('MODULES.NEWSPAPERS.PAGES.GROWL.ERROR.DELETED');
            }
        }).catch(function (error) {
            growl.error('MODULES.NEWSPAPERS.PAGES.GROWL.ERROR.DELETED');
        });
    };

    $scope.importProducts = function () {
        var fileModalInstance = $modal.open({
            templateUrl: 'views/application/newspapers/components/modal/products.tpl.html',
            controller: 'NewspaperPageProductsImportModalController',
            animation: true,
            size: 'lg',
            resolve: {
                modalData: function () {
                    return {
                        newspaperId: $scope.newspaperId
                    };
                }
            }
        });
        fileModalInstance.result.then(function () {
            $state.reload();
        }).catch(() => {});
    };
}]);

newspapersControllers.controller('NewspaperPageController', ['$scope', '$rootScope', '$state', '$stateParams', 'growl', 'NewspaperPage', '$filter', 'Newspaper', function ($scope, $rootScope, $state, $stateParams, growl, NewspaperPage, $filter, Newspaper) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});

    $scope.editMode = false;
    $scope.app_id = $stateParams.application_id;
    $scope.newspaperId = $stateParams.newspaperId;
    $scope.newspaperPageId = $stateParams.newspaperPageId;
    $scope.isLoading = false;

    $scope.newspaperPage = {
        app_id: $scope.app_id,
        newspaper_id: $scope.newspaperId
    };
    $scope.newspaper = {};

    $scope.recipes = [];
    $scope.products = [];
    $scope.headerTitle = [];

    if (angular.isDefined($stateParams.newspaperPageId)) {
        $scope.editMode = true;
    }

    if ($scope.editMode) {
        $scope.isLoading = true;
        NewspaperPage.get($stateParams.newspaperPageId)
            .then(function (response) {
                const data = response.data;
                if (data.success) {
                    $scope.newspaperPage = data.newspaperPage;
                    if (angular.equals($scope.newspaperPage.recipe, {})) {
                        delete $scope.newspaperPage.recipe;
                    }
                    if (angular.equals($scope.newspaperPage.products, {})) {
                        delete $scope.newspaperPage.products;
                    }
                    if (angular.equals($scope.newspaperPage.recipes, {})) {
                        delete $scope.newspaperPage.recipes;
                    }
                    $scope.headerTitle.push('-');
                    $scope.headerTitle.push($scope.newspaperPage.name);
                } else {
                    growl.error('MODULES.NEWSPAPERS.PAGES.GROWL.ERROR.' + data.error);
                }
            })
            .catch(function (error) {
                growl.error('MODULES.NEWSPAPERS.PAGES.GROWL.ERROR.GET');
            })
            .finally(function () {
                $scope.isLoading = false;
                $rootScope.doingResolve = false;
            });
    }

    Newspaper.get($scope.newspaperId)
        .then(function (response) {
            const data = response.data;
            if (data.success) {
                $scope.package_id = data.package_id;
                $scope.newspaper = data.newspaper;
                $scope.headerTitle.push('(' + $scope.newspaper.name + ')');
            } else {
                growl.error('MODULES.NEWSPAPERS.GROWL.ERROR.' + data.error);
            }
        })
        .catch(function (error) {
            growl.error('MODULES.NEWSPAPERS.GROWL.ERROR.GET');
        })
        .finally(function () {
            $rootScope.doingResolve = false;
            getProducts();
            $scope.isLoading = false;
        });

    var getProducts = function () {
        if ($scope.newspaper.promotion) {
            angular.forEach($scope.newspaper.promotion, function (value) {
                NewspaperPage.searchProducts($scope.app_id, value.id).then(function (response) {
                    const data = response.data;
                    if (data.success) {
                        $scope.products = $scope.products.concat(data.products);
                    } else {
                        growl.error('MODULES.NEWSPAPERS.PAGES.GROWL.ERROR.' + data.error);
                    }
                }).catch(function (error) {
                    growl.error('MODULES.NEWSPAPERS.PAGES.GROWL.ERROR.SEARCH_PRODUCTS');
                });
            });

        }
    };

    $scope.searchRecipes = function (text) {
        text = $filter('removeSpecial')(text);

        NewspaperPage.searchRecipes($scope.app_id, text).then(function (response) {
            const data = response.data;
            if (data.success) {
                $scope.recipes = data.recipes;
            } else {
                growl.error('MODULES.NEWSPAPERS.PAGES.GROWL.ERROR.' + data.error);
            }
        }).catch(function (error) {
            growl.error('MODULES.NEWSPAPERS.PAGES.GROWL.ERROR.SEARCH');
        });
    };

    $scope.setDisable = function (value) {
        return !(angular.equals(value, {}) || angular.equals(value, []) || angular.equals(value, null) || angular.equals(value, undefined));
    };

    $scope.changeParam = function (value) {
        $scope.newspaperPage[value] = null;
    };

    $scope.save = function () {
        $scope.$broadcast('show-errors-check-validity');

        if ($scope.newspaperPageForm.$valid) {
            $scope.isLoading = true;
            NewspaperPage.save($scope.newspaperPage, $scope.upload, $scope.editMode).then(function (response) {
                const data = response.data;
                if (data.success) {
                    growl.success('MODULES.NEWSPAPERS.PAGES.GROWL.SUCCESS.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                    $state.go('appsoup.application.newspaperPages', {
                        application_id: $scope.app_id,
                        newspaperId: $scope.newspaperId
                    });
                } else {
                    if (typeof data.error === 'object') {
                        if (data.error.image) {
                            $scope.fileError = true;
                        }
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.NEWSPAPERS.PAGES.GROWL.ERROR.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                    }
                }
            }).catch(function (error) {
                growl.error('MODULES.NEWSPAPERS.PAGES.GROWL.ERROR.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
            }).finally(function () {
                $scope.isLoading = false;
            });
        }
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.newspaperPages', {
            application_id: $scope.app_id,
            newspaperId: $scope.newspaperId
        });
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}]
    };
}]);

newspapersControllers.controller('NewspaperPageProductsImportModalController', ['$scope', '$rootScope', '$stateParams', '$state', 'NewspaperPage', 'growl', 'Permissions', '$modalInstance', 'modalData', '$translate', function ($scope, $rootScope, $stateParams, $state, NewspaperPage, growl, Permissions, $modalInstance, modalData, $translate) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.app_id = $stateParams.application_id;
    $scope.newspaperId = modalData.newspaperId;

    $scope.upload = undefined;
    $scope.isLoading = false;

    $scope.uploadSuccess = function (file) {
        $scope.isLoading = true;
        $scope.upload = file;

        NewspaperPage.importProducts($scope.app_id, $scope.newspaperId, $scope.upload).then(function (response) {
            const data = response.data;
            if (data.success) {
                growl.success('MODULES.APPLICATIONS.MODULES.USERS.IMPORT.SUCCESS');
                $modalInstance.close();
            } else {
                var transError = 'ERROR.CONTRACTOR.' + data.error;
                $translate(transError).then(function () {
                }, function () {
                    transError = data.error;
                }).finally(function () {
                    growl.error(transError);
                });
            }
        }).catch(function (error) {
            growl.error('MODULES.NEWSPAPERS.PAGES.GROWL.ERROR.IMPORT');
        }).finally(function () {
            $scope.isLoading = false;
        });
    };
}]);

newspapersControllers.controller('NewspaperImportShopController', ['$scope', '$rootScope', '$stateParams', '$state', 'NgTableParams', 'NewspaperImportShops', 'AppsoupAPI', 'growl', 'Permissions', function ($scope, $rootScope, $stateParams, $state, NgTableParams, NewspaperImportShops, AppsoupAPI, growl, Permissions) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('newspapers');
    $scope.app_id = $stateParams.application_id;
    $scope.newspaperId = $stateParams.newspaperId;
    $scope.canDeleteShop = false;

    var refresh = true;

    $scope.requiredFields = ['"Kod Sklepu"'];

    $scope.upload = undefined;
    $scope.isLoading = false;

    $scope.removeFile = function () {
        $scope.upload = undefined;
        $scope.errorRequired = true;
        $scope.fileUploaded = false;
    };

    $scope.uploadSuccess = function (file) {
        $scope.upload = file;
        $scope.errorRequired = false;
        $scope.fileUploaded = true;
        $scope.fileError = false;
        $scope.$apply();
    };

    $scope.getImportShopsExampleXls = function () {
        $scope.isLoading = false;
        NewspaperImportShops.getImportShopsExampleXls().then(function (response) {
            angular.openInNewTab(response.data);
        }).catch(function (error) {
            console.error('Error getting import shops example XLS:', error);
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    function refreshData() {
        $scope.searchShops({refresh: refresh});
        refresh = !refresh;
    }

    $scope.searchShops = function (search) {
        $scope.isFind = true;

        var find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.searchItem = $scope.search;
        $scope.isFind = false;
    };

    $scope.importShops = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;
        $scope.wrongData = [];
        NewspaperImportShops.importShops($scope.app_id, $scope.newspaperId, $scope.upload).then(function (response) {
            const data = response.data;
            if (data.success) {
                $scope.imported = true;
                $scope.wrongData = data.wrongData;
                growl.success('MODULES.APPLICATIONS.MODULES.USERS.IMPORT.SUCCESS');
            } else {
                growl.error(data.error, {title: 'IMPORT.HEADER.DEFAULT'});
            }
        }).catch(function (error) {
            growl.error('MODULES.NEWSPAPERS.PAGES.GROWL.ERROR.IMPORT_SHOPS');
        }).finally(function () {
            $scope.isLoading = false;
            refreshData();
        });
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.newspapers');
    };

    //Table
    $scope.tableParams = new NgTableParams(AppsoupAPI.getIdTableParams(), {
        getData: function (params) {

            $scope.isLoading = true;
            return NewspaperImportShops.getData($scope.app_id, $scope.newspaperId, params._params)
                .then(function (response) {
                    return response.data.shops;
                })
                .finally(function () {
                    $scope.isLoading = false;
                    $scope.isFind = false;
                    $scope.canDeleteShop = true;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.removeImportedShop = function (params, index) {
        $scope.newspaperId = params.newspaperId;
        $scope.shopId = params.shopId;

        NewspaperImportShops.remove($scope.newspaperId, $scope.shopId).then(function (response) {
            const data = response.data;
            if (data.success) {
                growl.success('MODULES.NEWSPAPERS.PAGES.GROWL.SUCCESS.DELETED');
                $scope.tableParams.data.splice(index, 1);
            } else {
                growl.error('MODULES.NEWSPAPERS.PAGES.GROWL.ERROR.DELETED');
            }
        }).catch(function (error) {
            growl.error('MODULES.NEWSPAPERS.PAGES.GROWL.ERROR.DELETED');
        });
    };
}]);

export default newspapersControllers;
